import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
// import { NgbNavModule, NgbAccordionModule, NgbDropdownModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
// import lottie from 'lottie-web';
// import { FooterComponent } from '../layouts/footer/footer.component';
import { FieldErrorDisplayComponent } from './components/field-error-display/field-error-display.component';
import { OnlynumberDirective } from './directive/onlynumber.directive';
import { OnlydecimalDirective } from './directive/onlydecimals.directive';
import { AlphaNumericDirective } from './directive/alphanumeric.directive';
import { AlphaNumericSpaceDirective } from './directive/alphanumricspace.directive';
import { NumericDirective } from './directive/numeric.directive';
import { AlphabetsDirective } from './directive/onlyalphabets.directive';
import { PhoneMaskDirective } from './directive/phonemask.directive';
import { NgbdGridJsSortableHeader } from './directive/gridjs-sortable.directive';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { RouteDataProvider } from './providers/RouteDataProvider';
import { AuthGuard } from './providers/AuthGuard';

import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ImageService } from './services/image/image.service';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { NgbAccordionModule, NgbModule, NgbNavModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';




@NgModule({
  declarations: [
    FieldErrorDisplayComponent,
    OnlynumberDirective,
    OnlydecimalDirective,
    AlphaNumericDirective,
    AlphaNumericSpaceDirective,
    NumericDirective,
    AlphabetsDirective,
    PhoneMaskDirective,
    HeaderComponent,
    FooterComponent,
    NgbdGridJsSortableHeader,
    // ResetPasswordComponent,
    // TermsComponent,
    
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    NgbPaginationModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbModule
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    FieldErrorDisplayComponent,
    OnlynumberDirective,
    OnlydecimalDirective,
    AlphaNumericDirective,
    AlphaNumericSpaceDirective,
    NumericDirective,
    AlphabetsDirective,
    PhoneMaskDirective,
    NgbdGridJsSortableHeader,
    // ResetPasswordComponent,
    HeaderComponent,
    FooterComponent,
    // TermsComponent
    
   
  ],
  providers:[
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    // ImageService
   
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class SharedModule { 
  // constructor() {
  //   defineElement(lottie.loadAnimation);
  // }

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        RouteDataProvider, 
        AuthGuard, 
        DatePipe,
        TitleCasePipe
      ]
    };
  }
}

